import { faLightbulb } from '@fortawesome/pro-solid-svg-icons/faLightbulb';
import type { LinkOutContent, LinkOutRoute } from './types';

export const RECOMMENDATIONS_CONTENT: LinkOutContent = {
  title: 'Recommendations',
  heading: 'See your recommendations in the new App',
  message: 'Insights Feed is now Recommendations in the new Appcues App.',
  icon: faLightbulb,
};

const routes: LinkOutRoute[] = [
  {
    pattern: /^\/insights-feed\/?$/i,
    resolve: () => '/recommendations',
    content: RECOMMENDATIONS_CONTENT,
    examples: ['/insights-feed'],
  },
];

export default routes;
